import { render, staticRenderFns } from "./FactoringMarketingInternoCampañasCampañas.vue?vue&type=template&id=5f605476"
import script from "./FactoringMarketingInternoCampañasCampañas.vue?vue&type=script&lang=js"
export * from "./FactoringMarketingInternoCampañasCampañas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports